var Flickity = require('flickity');
var imagesLoaded = require('flickity-imagesloaded');

const sliders = document.querySelectorAll('.Slider__group');

for (const slider of sliders) {
  const flkty = new Flickity(slider, {
    pageDots: false,
    imagesLoaded: true,
  });
}
